import { ReactNode, forwardRef } from 'react';

import {
  Typography as Text,
  TypographyProps as TextProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    fontWeight: 600,
  },
});

export interface TitleProps
  extends Omit<TextProps, 'classes'>,
    WithStyles<typeof styles> {
  children: ReactNode;
}

const Title = forwardRef<HTMLDivElement, TitleProps>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <Text
      ref={ref}
      component="div"
      variant="body2"
      className={classNames(classes?.root, className)}
      {...rest}
    >
      {children}
    </Text>
  );
});

Title.displayName = 'ActivityFeedItem.Title';

export default withStyles(styles)(Title);
